import MainProductHero from "./MainProductHero"

export default MainProductHero
